import moment from "moment";
import { ModalTopSection } from "../../../components/DetailsModal/ModalTopSection";
import { TopDownFlexedContainer } from "../../../components/DetailsModal/TopDownFlexedContainer";
import {
  CopyButton,
  DataLoadingView,
  ErrorOccuredView,
  ModalContainer,
  PaymentsList,
  SectionSubheader,
  StructuredList,
  SwitchAppButton,
} from "../../../components";
import { ModalSectionTitle } from "../../../components";
import { LeftRightFlexedContainer } from "../../../components";
import { CurrencyDisplay } from "../../../components";
import { Badge } from "../../../components";
import { IPaymentDetailsModalViewProps } from "./PaymentDetailsModal";
import {
  applySecurityMask,
  getPaymentStatusIndicator,
  truncateStringWithEllipsis,
} from "../../../utils";
import { appConfig } from "../../../configs";
import { Link } from "react-router-dom";
import { PartialPaymentsContainedView } from "./PartialPaymentsContainedView";
import { transactionStatus } from "../../../enums";
import { LinkedPayouts } from "./LinkedPayouts";

export const View = (props: IPaymentDetailsModalViewProps) => {
  const containsPartialPayments =
    props.modalData && props.modalData?.partial_payments.length > 0;

  const isSuccessfulOrParitial =
    props.modalData &&
    (props.modalData.status === transactionStatus.successful ||
      props.modalData.status === transactionStatus.partial);

  const statusIndicator = props.modalData
    ? getPaymentStatusIndicator(props.modalData)
    : null;

  const customerFullName =
    props.modalData?.initialized_customer?.full_name ??
    props.modalData?.customer.full_name;
  const customerEmail =
    props.modalData?.initialized_customer?.email ??
    props.modalData?.customer.email;
  const customerAddress =
    props.modalData?.initialized_customer?.address ??
    props.modalData?.customer.address;
  const customerPhoneNumber =
    props.modalData?.initialized_customer?.phone_number ??
    props.modalData?.customer.phone_number;

  const isBankTransferPayment =
    props.modalData?.is_virtual_account_checkout ||
    props.modalData?.is_dedicated_virtual_account_checkout ||
    !!props.modalData?.bank_trsf_account_number;

  const isCardPayment =
    props.modalData?.is_direct_card_charge || !!props.modalData?.card_pan;

  return (
    <div className="payment-details-container">
      <ModalContainer
        isModalOpen={props.isModalOpen}
        closeModal={props.closeModal}
        className="payment-modal-container"
        modalHeader={
          !props.modalData ? (
            <SectionSubheader title="PAYMENT DETAILS" />
          ) : (
            <ModalTopSection
              header="PAYMENT DETAILS"
              subHeader={
                <div className="sub-header flex-container justify-content--start mt-5">
                  <div>
                    <CurrencyDisplay
                      currencyOrSymbol={props.modalData.currency}
                      amount={props.modalData.amount}
                    />
                  </div>

                  <Badge
                    text={statusIndicator!.statusText}
                    statusColor={statusIndicator!.statusType}
                  />
                </div>
              }
              copyText="Transaction ID"
              copyContent={props.modalData.id}
              closeModal={props.closeModal}
            />
          )
        }
      >
        {!props.modalData ? (
          <>
            {props.isLoading ? (
              <DataLoadingView message={"Loading transaction details"} />
            ) : props.isError || !props.modalData ? (
              <ErrorOccuredView
                message={
                  "An error occured while loading the transaction. Please retry..."
                }
              />
            ) : null}
          </>
        ) : (
          <>
            <div className="sections flex-container flex-break--small">
              <TopDownFlexedContainer
                key_id="Date"
                value={
                  <span className="date--oneline">
                    {moment(props.modalData.created_at).format(
                      appConfig.dateTimeFormat
                    )}
                  </span>
                }
              />

              <div className="flex-divider--vertical" />

              <TopDownFlexedContainer key_id="Customer" value={customerEmail} />

              <div className="flex-divider--vertical" />

              <TopDownFlexedContainer
                key_id="Payment summary"
                value={
                  <div className="flex-container row">
                    <p>gateway: </p>
                    {!props.modalData.gateway_code ? (
                      "-"
                    ) : (
                      <img
                        src={`${process.env.PUBLIC_URL}/gateway-logos/${props.modalData.gateway_code}.svg`}
                        alt="gateway logo"
                        className="gateway-image"
                        style={{
                          width: "50%",
                          marginLeft: "5px",
                        }}
                        title={props.modalData.gateway_code}
                      />
                    )}
                  </div>
                }
              />

              <div className="flex-divider--vertical" />

              <TopDownFlexedContainer key_id="Risk evaluation" value="##" />
            </div>

            <div>
              <ModalSectionTitle
                key_id="Payment Details"
                value={
                  <Link
                    to={`/payments?id=${props.modalData.id}`}
                    className="switchapp-link"
                  >
                    View all
                  </Link>
                }
              />

              <LeftRightFlexedContainer
                key_id="Transaction ID"
                value={
                  <div className="flex-container justify-content--start align-items--center">
                    <div className="transaction-id-text modal-header--title">
                      <span title={props.modalData.id}>
                        {truncateStringWithEllipsis(props.modalData.id, 25)}
                      </span>
                    </div>
                    <div className="copy-button--container ml-5">
                      <CopyButton
                        stringToCopy={props.modalData.id}
                        iconDescription="copy ID"
                        className="copy-btn"
                      />
                    </div>
                  </div>
                }
              />

              <LeftRightFlexedContainer
                key_id="Reference"
                value={
                  <div className="flex-container justify-content--start align-items--center">
                    <div className="transaction-id-text modal-header--title">
                      {props.modalData.tx_ref}
                    </div>
                    <div className="copy-button--container ml-5">
                      <CopyButton
                        stringToCopy={props.modalData.tx_ref}
                        iconDescription="copy reference"
                        className="copy-btn disable-show-details"
                      />
                    </div>
                  </div>
                }
              />

              <LeftRightFlexedContainer
                key_id="Amount"
                value={
                  <>
                    <CurrencyDisplay
                      currencyOrSymbol={props.modalData.currency}
                      amount={props.modalData.amount}
                      amountFontSize={16}
                      symbolFontSize={12}
                    />{" "}
                    ({props.modalData.currency})
                  </>
                }
              />

              <LeftRightFlexedContainer
                key_id="Amount Paid"
                value={
                  <>
                    <CurrencyDisplay
                      currencyOrSymbol={props.modalData.currency}
                      amount={props.modalData.amount_paid}
                      amountFontSize={16}
                      symbolFontSize={12}
                    />{" "}
                    ({props.modalData.currency})
                  </>
                }
              />

              <LeftRightFlexedContainer
                key_id="Amount Charged"
                value={
                  <>
                    <CurrencyDisplay
                      currencyOrSymbol={props.modalData.currency}
                      amount={props.modalData.charged_amount}
                      amountFontSize={16}
                      symbolFontSize={12}
                    />{" "}
                    ({props.modalData.currency})
                  </>
                }
              />

              <LeftRightFlexedContainer
                key_id="App Fee(s)"
                value={
                  <>
                    <CurrencyDisplay
                      currencyOrSymbol={props.modalData.currency}
                      amount={props.modalData.app_fee}
                      amountFontSize={16}
                      symbolFontSize={12}
                    />{" "}
                    ({props.modalData.currency})
                  </>
                }
              />

              <LeftRightFlexedContainer
                key_id="Charge Bearer"
                value={
                  <Badge
                    text={props.modalData.bearer.toUpperCase()}
                    statusColor={"secondary"}
                    hideIndicator
                  />
                }
              />

              {props.modalData.total_standing_order_deductions === 0 ? null : (
                <LeftRightFlexedContainer
                  key_id="Deductions (Loans)"
                  value={
                    <>
                      <CurrencyDisplay
                        currencyOrSymbol={props.modalData.currency}
                        amount={props.modalData.total_standing_order_deductions}
                        amountFontSize={16}
                        symbolFontSize={12}
                      />{" "}
                      ({props.modalData.currency})
                    </>
                  }
                />
              )}

              {props.modalData.total_affiliate_deductions === 0 ? null : (
                <LeftRightFlexedContainer
                  key_id="Affiliate Deductions (Links)"
                  value={
                    <>
                      <CurrencyDisplay
                        currencyOrSymbol={props.modalData.currency}
                        amount={props.modalData.total_affiliate_deductions}
                        amountFontSize={16}
                        symbolFontSize={12}
                      />{" "}
                      ({props.modalData.currency})
                    </>
                  }
                />
              )}

              {!isSuccessfulOrParitial ? null : (
                <LeftRightFlexedContainer
                  key_id="Amount Settled"
                  value={
                    <>
                      <CurrencyDisplay
                        currencyOrSymbol={props.modalData.currency}
                        amount={props.modalData.amount_settled ?? 0}
                        amountFontSize={16}
                        symbolFontSize={12}
                      />{" "}
                      ({props.modalData.currency})
                    </>
                  }
                />
              )}

              <LeftRightFlexedContainer
                key_id="Status"
                value={
                  <Badge
                    text={statusIndicator!.statusText}
                    statusColor={statusIndicator!.statusType}
                  />
                }
              />
              <LeftRightFlexedContainer
                key_id="Description"
                value={props.modalData.description || "..."}
              />
              <LeftRightFlexedContainer
                key_id="Message"
                value={props.modalData.narration || "..."}
              />
            </div>

            <div>
              <ModalSectionTitle key_id="Customer Details" value={""} />

              <LeftRightFlexedContainer
                key_id="Customer name"
                value={customerFullName || "(Anonymous)"}
              />
              <LeftRightFlexedContainer
                key_id="Customer email"
                value={
                  <div className="flex-container justify-content--start align-items--center no-wrap">
                    <div className="transaction-id-text modal-header--title">
                      <span title={customerEmail}>{customerEmail}</span>
                    </div>
                    <div className="copy-button--container ml-3">
                      <CopyButton
                        // name="copy-customer-button"
                        stringToCopy={customerEmail || "--"}
                        iconDescription="copy customer email"
                        className="copy-btn"
                      />
                    </div>
                  </div>
                }
              />
              <LeftRightFlexedContainer
                key_id="Customer Phone"
                value={customerPhoneNumber}
              />
              <LeftRightFlexedContainer
                key_id="Customer Address"
                value={customerAddress}
              />
              <LeftRightFlexedContainer
                key_id="Date added"
                value={
                  <span className="date--oneline">
                    {moment(props.modalData.created_at).format(
                      appConfig.dateTimeFormat
                    )}
                  </span>
                }
              />
            </div>

            {containsPartialPayments ? null : (
              <div>
                <ModalSectionTitle key_id="Payment Method" value={""} />

                <LeftRightFlexedContainer
                  key_id="Payment Method"
                  value={
                    <span className="font-ctm--bold">
                      {props.modalData.payment_type || "..."}
                    </span>
                  }
                />
                <LeftRightFlexedContainer
                  key_id="Payment Gateway"
                  value={
                    !props.modalData.gateway_code ? (
                      "-"
                    ) : (
                      <img
                        src={`${process.env.PUBLIC_URL}/gateway-logos/${props.modalData.gateway_code}.svg`}
                        alt="gateway logo"
                        className="gateway-logo-full"
                        title={props.modalData.gateway_code}
                      />
                    )
                  }
                />

                {!isBankTransferPayment ? null : (
                  <>
                    <LeftRightFlexedContainer
                      key_id="Bank Name"
                      value={
                        <span className="font-ctm--bold">
                          {props.resolvedBankNameFromBankCode || "..."}
                        </span>
                      }
                    />
                    <LeftRightFlexedContainer
                      key_id="Account Number"
                      value={
                        <span className="font-ctm--bold">
                          {applySecurityMask(
                            props.modalData.bank_trsf_account_number || "...",
                            4,
                            "middle"
                          )}
                        </span>
                      }
                    />
                    <LeftRightFlexedContainer
                      key_id="Account Name"
                      value={
                        <span className="font-ctm--bold">
                          {props.modalData.bank_trsf_account_name || "..."}
                        </span>
                      }
                    />
                  </>
                )}

                {!isCardPayment ? null : (
                  <>
                    <LeftRightFlexedContainer
                      key_id="PAN"
                      value={
                        <span className="font-ctm--bold">
                          {props.modalData.card_pan || "..."}
                        </span>
                      }
                    />

                    <LeftRightFlexedContainer
                      key_id="Expiry Date"
                      value={
                        <span className="font-ctm--bold">
                          {props.modalData.card_expiry || "..."}
                        </span>
                      }
                    />

                    <LeftRightFlexedContainer
                      key_id="Card Type"
                      value={
                        <span className="font-ctm--bold">
                          {props.modalData.card_type || "..."}
                        </span>
                      }
                    />
                  </>
                )}
              </div>
            )}

            {!props.modalData.sale ||
            !props.modalData.sale.line_items.length ? null : (
              <div>
                <ModalSectionTitle
                  key_id="ITEMS SOLD"
                  value=""
                  noBottomBorder
                />

                <div className="mb-5 pl-5 pr-5 pt-5 pb-5 bordered border-dotted b-r-5">
                  <StructuredList
                    isCondensed
                    headers={
                      <div className="cds--structured-list-row cds--structured-list-row--header-row">
                        <div className="cds--structured-list-th">##</div>
                        <div className="cds--structured-list-th">
                          PRODUCT NAME
                        </div>
                        <div className="cds--structured-list-th">
                          UNIT PRICE ({props.modalData.currency})
                        </div>
                        <div className="cds--structured-list-th">QTY</div>
                        <div className="cds--structured-list-th">TOTAL</div>
                      </div>
                    }
                    {...{
                      rows: props.modalData.sale.line_items.map(
                        (saleItem, index) => (
                          <div className="cds--structured-list-tbody">
                            <div className="cds--structured-list-row">
                              <div className="cds--structured-list-td">
                                {/* <img
                          src={item.product_icon || imagePlaceholder}
                          alt="product icon"
                          className="paymentlink-list--product-icon"
                        /> */}
                                {index + 1}
                              </div>
                              <div className="cds--structured-list-td">
                                {saleItem.product_name}
                              </div>
                              <div className="cds--structured-list-td">
                                {saleItem.price}
                              </div>
                              <div className="cds--structured-list-td">
                                {saleItem.qty}
                              </div>
                              <div className="cds--structured-list-td">
                                {saleItem.qty * saleItem.price}
                              </div>
                            </div>
                          </div>
                        )
                      ),
                    }}
                  />

                  <ModalSectionTitle key_id="Delivery Details" value={""} />

                  <LeftRightFlexedContainer
                    key_id="Deliver To"
                    value={customerFullName || "(Anonymous)"}
                  />
                  <LeftRightFlexedContainer
                    key_id="Delivery email"
                    value={
                      <div className="flex-container justify-content--start align-items--center no-wrap">
                        <div className="transaction-id-text modal-header--title">
                          <span title={customerEmail}>{customerEmail}</span>
                        </div>
                        <div className="copy-button--container ml-3">
                          <CopyButton
                            // name="copy-customer-button"
                            stringToCopy={customerEmail || "--"}
                            iconDescription="copy delivery email"
                            className="copy-btn"
                          />
                        </div>
                      </div>
                    }
                  />
                  <LeftRightFlexedContainer
                    key_id="Delivery Phone"
                    value={customerPhoneNumber}
                  />
                  <LeftRightFlexedContainer
                    key_id="Delivery Address"
                    value={customerAddress}
                  />
                </div>
              </div>
            )}

            {containsPartialPayments ? (
              <div>
                <ModalSectionTitle
                  key_id={
                    <>
                      <span className="">
                        Partial Payments In This Transaction
                      </span>{" "}
                      <span className="text-primary">
                        [ {props.modalData.partial_payments_count} ]
                      </span>
                    </>
                  }
                  value={""}
                />

                <PartialPaymentsContainedView
                  partialPaymentTransactions={props.modalData.partial_payments}
                />
              </div>
            ) : null}

            {!isSuccessfulOrParitial ? null : (
              <div>
                <ModalSectionTitle
                  key_id={
                    <span className="text-success">Transaction Payouts</span>
                  }
                  value={""}
                />

                <LinkedPayouts tx_ref={props.modalData.tx_ref} />
              </div>
            )}

            <div>
              <ModalSectionTitle
                key_id={
                  <span className="">Other recent payments from customer</span>
                }
                value={""}
              />

              <PaymentsList
                search={props.customerPaymentsSearchQuery || ""}
                enabled={props.enableSearchCustomerPayments}
                loadingMessage="Loading other payments by this customer..."
                filterList={(tx) => tx.tx_ref !== props.modalData?.tx_ref}
              />
            </div>

            {props.modalData.status === transactionStatus.processing ? null : (
              <div>
                <ModalSectionTitle
                  key_id={<span className="">Transaction Webhook Status</span>}
                  value={
                    <div className="flex-container justify-content--end align-items--end btn-container mt-5">
                      <SwitchAppButton
                        kind="secondary"
                        onClick={props.resendTxWebhook}
                        size="sm"
                        className="d-none d-md-inherit"
                      >
                        Resend Webhook
                      </SwitchAppButton>
                    </div>
                  }
                />

                <LeftRightFlexedContainer
                  key_id="Webhook Sent"
                  value={props.modalData.is_webhook_sent
                    .toString()
                    .toUpperCase()}
                />

                <LeftRightFlexedContainer
                  key_id="Webhook Confirmed"
                  value={props.modalData.is_webhook_confirmed
                    .toString()
                    .toUpperCase()}
                />

                {!props.modalData.is_webhook_confirmed ? null : (
                  <LeftRightFlexedContainer
                    key_id="Webhook ConfirmedAt"
                    value={props.modalData.webhook_confirmed_timestamp}
                  />
                )}

                {!props.modalData.is_webhook_failed ? null : (
                  <>
                    <LeftRightFlexedContainer
                      key_id="Webhook Failed"
                      value={props.modalData.is_webhook_failed
                        .toString()
                        .toUpperCase()}
                    />

                    <LeftRightFlexedContainer
                      key_id="Failed Count"
                      value={props.modalData.webhook_failed_count}
                    />

                    <LeftRightFlexedContainer
                      key_id="Retries Count"
                      value={props.modalData.webhook_retries_count}
                    />

                    <LeftRightFlexedContainer
                      key_id="Resend Request(s)"
                      value={props.modalData.webhook_resend_request_count}
                    />
                  </>
                )}
              </div>
            )}
          </>
        )}
      </ModalContainer>
    </div>
  );
};
